// SHARK-2427
// TODO: delete all data after a/b test is complete revert the changes by the comments

/**
 * SHARK-2427
 * All changes for a/b test will be commented as should be deleted once A/B test is complete
 * everything between commented lines can be deleted
 *
 * e.g
 * // A/B test code SHARK-2427 -- start
 * function somethingForABTest () {
 *  doingsomethingserious();
 *  return "hooray"
 * }
 * // A/B test code SHARK-2427 -- end
 *
 */
// A/B test code SHARK-2427 -- start
const GDPR_IS_OFF_KEY = 'ab-gdpr';

export function gdprisOff() {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(GDPR_IS_OFF_KEY);
  }
  return false;
}
// A/B test code SHARK-2427 -- start
